export const CustomButton = ({ children, ...props }) => {
  return (
    <>
      <button type="button" {...props}>
        {children}
      </button>
    </>
  );
};
